import { Box, Button, Typography, useTheme, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { Tooltip } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';

const Products = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [products, setProducts] = useState(null);
  const { currentuser, base_url, setRequest } = useContext(AuthContext);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.token}`
    },
    responseType: 'blob',
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.post(`${base_url}/ethioglobal/products/all`, config);
      console.log(response.data);
      setProducts(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const columns = [
    {
      field: "companyname",
      headerName: "Supplier",
      flex: 1,
      renderCell: (params) => {
          // Assuming products is an array and you want to show the names of all products
          const productNames = params.row.company.companyname;
          return (
              <Tooltip title={productNames} arrow>
                  <span>{productNames}</span>
              </Tooltip>
          );
      },
    },
    {
      field: "productname",
      headerName: "Product Name",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "unitPrice",
      headerName: "Unit Price",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "installmentMonths",
      headerName: "Installment Months",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "brand",
      headerName: "Brand",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 1,
      hide: isSmallScreen,
      valueFormatter: ({ value }) => new Date(value).toLocaleString(),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "id",
      headerName: "Details",
      flex: 1,
      renderCell: (params) => {
        const { id } = params.row;

        return (
        <Tooltip title="Settings" arrow>
          <span
            style={{
              cursor: 'pointer',
              display: 'flex',
              marginRight: 10,
              alignItems: 'center',
              justifyContent: 'flex-end',
              height: '100%',
              width: '100%',
            }}
            onClick={ () => {
              setRequest(params.row);
              navigate(`/product/${id}`)
            }}
          >
            <SettingsIcon />
          </span>
        </Tooltip>
      )},
    },
  ];

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
      <Header subtitle="Products List" />
        {/* <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate('/suppliers/add')} // Replace with your route
        >
          New Supplier
        </Button> */}
      </Box>
      <Box
        m="0px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        {products !== null ? 
          <DataGrid 
            rows={products} 
            columns={columns} 
            pageSize={5} 
            rowsPerPageOptions={[5]} 
            sx={{
              '& .overflow-cell': overflowCellStyle,
            }}
          />
          :
          <Typography>No rows to show.</Typography>
        }
      </Box>
    </Box>
  );
};

const overflowCellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default Products;